import { EventTime } from '../event.time';
import { RecurrenceRule } from '../recurrence.rule';
import { OccurrenceGenerator } from './occurrence.generator';

export class EventGenerator implements OccurrenceGenerator {
  generate(rule: RecurrenceRule): EventTime[] {
    return [{
      startTime: rule.range.startDateTime,
      endTime: rule.range.endDateTime || null,
      isAllDay: rule.isAllDay,
      isEndAllDay: rule.isEndAllDay,
    }];
  }
}
